import ConectadosPage from '../pages/ConectadosPage';
import CategoryPage from '../pages/CategoryPage';
import QuestionPage from '../pages/QuestionPage';
import { ProtectedRoute } from '../components';
import Conecta2ProductPage from '../../../pages/Conecta2ProductPage';

export const conectadosRoutes = [
  {
    path: 'conectados',
    element: (
      <ProtectedRoute>
        <ConectadosPage />
      </ProtectedRoute>
    )
  },
  {
    path: 'conectados/:category',
    element: (
      <ProtectedRoute>
        <CategoryPage />
      </ProtectedRoute>
    )
  },
  {
    path: 'conectados/:category/:subcategory/question',
    element: (
      <ProtectedRoute>
        <QuestionPage />
      </ProtectedRoute>
    )
  },
  {
    path: 'conectados/producto',
    element: <Conecta2ProductPage />
  }
]; 